// @flow
import Dispatcher from 'dispatcher';
import { Store } from '@homie/flux';
import { SET_TENANT_REPORT } from 'modules/external_tenant/api/action_types/TenantReportActionTypes';

let _report = {};

class TenantReportStore extends Store {
  constructor() {
    super();
    Dispatcher.register(this.reducer);
  }

  getReport() {
    return _report;
  }

  reducer = (action: any) => {
    switch (action.type) {
      case SET_TENANT_REPORT:
        _report = action.payload;
        break;
    }

    this.notify();
  };
}

export default new TenantReportStore();
